import { render, staticRenderFns } from "./ProjectStatisticsFwf.vue?vue&type=template&id=36fe0186&scoped=true&"
import script from "./ProjectStatisticsFwf.vue?vue&type=script&lang=js&"
export * from "./ProjectStatisticsFwf.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStatisticsFwf.vue?vue&type=style&index=0&id=36fe0186&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe0186",
  null
  
)

export default component.exports